import { toast } from 'react-toastify';

// Shared by the Store settings "View Store" button and the StoreSwitcher
// launch icon, so both open a store the same way:
//  - no domain yet -> a warning (never a silently disabled button);
//  - iframe store  -> views/settings/iframePreview.js in a new tab, standing in
//    for the host app that embeds it (members only reach it via a signed JWT);
//  - standalone    -> openStandalone(), i.e. LaunchStoreModal (log in as me /
//    a registered customer / a guest).
export const launchStore = (store, openStandalone) => {
	if (!store?.storeDomain) {
		toast.warning("Set this store's domain in Store - General to view the store.");
		return;
	}
	if (store.storefrontType === 'iframe') {
		window.open(`/iframe-preview?storeId=${store.storeId}`, '_blank');
		return;
	}
	openStandalone();
};
